import { connection } from "./connection";

const userDetailFields = `
  avatar
  fullName
`;

const messageFields = `
  _id
  conversationId
  customerId
  user {
    _id
    details {
      ${userDetailFields}
    }
  }
  content
  createdAt
  internal
  fromBot
  runId
  metadata
  contentType
  engageData {
    content
    kind
    sentAs
    messageId
    brandId
  }
  botData
  messengerAppData
  attachments {
    url
    name
    size
    type
  }
`;

const userFields = `
  _id
  isActive
  details {
    ${userDetailFields}
    shortName
    location
  }
  isOnline
`;

const conversationDetailQuery = `
  query ($_id: String, $integrationId: String!, $customerId: String, $visitorId: String) {
    widgetsConversationDetail(_id: $_id, integrationId: $integrationId, customerId: $customerId, visitorId: $visitorId) {
      _id
      messages {
        ${messageFields}
      }

      operatorStatus
      isOnline
      supporters {
        _id
        details {
          ${userDetailFields}
        }
      }
      participatedUsers {
        _id
        details {
          ${userDetailFields}
          shortName
          description
          position
          location
        }
        links
      }
    }
  }
`;

const widgetExportMessengerDataQuery = `
  query widgetExportMessengerData($_id: String, $integrationId: String!) {
    widgetExportMessengerData(_id: $_id, integrationId:$integrationId)
  }
`;

const conversationMessageInserted = `
  subscription conversationMessageInserted($_id: String!) {
    conversationMessageInserted(_id: $_id) {
      ${messageFields}
    }
  }
`;

const conversationBotTypingStatus = `
  subscription conversationBotTypingStatus($_id: String!) {
    conversationBotTypingStatus(_id: $_id)
  }
`;

const conversationMessageStreamSubscription = `
  subscription conversationMessageStreamSubscription($_id: String!) {
    conversationMessageStreamSubscription(_id: $_id)
  }
`;

const conversationReasoningStream = `
  subscription conversationReasoningStream($_id: String!) {
    conversationReasoningStream(_id: $_id)
  }
`;

const adminMessageInserted = `
  subscription conversationAdminMessageInserted($customerId: String) {
    conversationAdminMessageInserted(customerId: $customerId) {
      unreadCount
    }
  }
`;

const unreadCountQuery = `
  query widgetsUnreadCount($conversationId: String, $customerId: String, $visitorId: String) {
    widgetsUnreadCount(conversationId: $conversationId, customerId: $customerId, visitorId: $visitorId)
  }
`;

const messengerSupportersQuery = `
  query widgetsMessengerSupporters($integrationId: String!) {
    widgetsMessengerSupporters(integrationId: $integrationId) {
      supporters {
        ${userFields}
      }
      isOnline
    }
  }
`;

const totalUnreadCountQuery = `
  query widgetsTotalUnreadCount(${connection.queryVariables}) {
    widgetsTotalUnreadCount(${connection.queryParams})
  }
`;

const conversationChanged = `
  subscription conversationChanged($_id: String!) {
    conversationChanged(_id: $_id) {
      type
    }
  }
`;

const allConversations = `
  query widgetsConversations(${connection.queryVariables}) {
    widgetsConversations(${connection.queryParams}) {
      _id
      content
      createdAt
      participatedUsers {
        details {
          ${userDetailFields}
        }
      }
    }
  }
`;

const getEngageMessage = `
  query widgetsGetEngageMessage($integrationId: String $customerId: String $visitorId: String $browserInfo: JSON!) {
    widgetsGetEngageMessage(integrationId: $integrationId customerId: $customerId visitorId: $visitorId browserInfo: $browserInfo) {
      ${messageFields}
    }
  }
`;

const readConversationMessages = `
  mutation widgetsReadConversationMessages($conversationId: String) {
    widgetsReadConversationMessages(conversationId: $conversationId)
  }
`;
const conversationMessageFeedback = `
  mutation conversationMessageFeedback($_id: String!, $score: Float!, $note: String ) {
    conversationMessageFeedback(_id: $_id, score: $score, note: $note)
  }
`;

const removeConversationMessageFeedback = `
  mutation removeConversationMessageFeedback($_id: String!) {
    removeConversationMessageFeedback(_id: $_id)
  }
`;

const connect = (isLivekitEnabled?: boolean) => `
  mutation connect($labelId: String, $userId: String, $brandCode: String, $origin: String, $integrationId: String, $email: String, $phone: String, $code: String
    $isUser: Boolean, $data: JSON,
    $companyData: JSON, $cachedCustomerId: String $visitorId: String, $isLead: Boolean, $currentLanguage: String) {

    widgetsMessengerConnect(labelId: $labelId, userId: $userId, brandCode: $brandCode, origin: $origin, email: $email, phone: $phone, code: $code, integrationId: $integrationId,
      isUser: $isUser, data: $data, companyData: $companyData,
      cachedCustomerId: $cachedCustomerId, visitorId: $visitorId, isLead: $isLead, currentLanguage: $currentLanguage) {
      integrationId,
      messengerData,
      ${isLivekitEnabled
    ? `
      callData {
        header
        description
        departments {
          _id
          name
          operators
        }
        isReceiveWebCall
        avatarUrl
        modelConfig
      },
    `
    : ''
  }
      languageCode,
      uiOptions,
      customerId,
      visitorId,
      sessionToken,
      brand {
        name
        description
      }
    }
  }
`;

const saveBrowserInfo = `
  mutation widgetsSaveBrowserInfo($customerId: String $visitorId: String $browserInfo: JSON!) {
    widgetsSaveBrowserInfo(customerId: $customerId visitorId: $visitorId browserInfo: $browserInfo) {
      ${messageFields}
    }
  }
`;

const sendTypingInfo = `
  mutation widgetsSendTypingInfo($conversationId: String!  $text: String) {
    widgetsSendTypingInfo(conversationId: $conversationId text: $text)
  }
`;

// faq

const faqFields = `
  _id
  title
  summary
  content
  createdDate
`;

const categoryFields = `
  _id
  title
  description
  numOfArticles
  parentCategoryId
  icon
`;

const getFaqCategoryQuery = `
  query knowledgeBaseCategoryDetail($_id: String!) {
    knowledgeBaseCategoryDetail(_id: $_id) {
      ${categoryFields}
      parentCategoryId
      articles {
        ${faqFields}
      }
    }
  }
`;

const getFaqTopicQuery = `
  query knowledgeBaseTopicDetail($_id: String!) {
    knowledgeBaseTopicDetail(_id: $_id) {
      title
      description
      categories {
        ${categoryFields}
      }
      parentCategories {
        ${categoryFields}
      }
    }
  }
`;

const faqSearchArticlesQuery = `
  query widgetsKnowledgeBaseArticles($topicId: String!, $searchString: String!) {
    widgetsKnowledgeBaseArticles(topicId: $topicId, searchString: $searchString) {
      ${faqFields}
    }
  }
`;

const integrationsFetchApi = `
  query integrationsFetchApi($path: String!, $params: JSON!) {
    integrationsFetchApi(path: $path, params: $params)
  }
`;

// livekitcall

const USER_DETAIL_FIELD = `
  avatar
  fullName
`;

const MESSAGE_FIELDS = `
  _id
  conversationId
  customerId
  user {
    _id
    details {
      ${USER_DETAIL_FIELD}
    }
  }
  content
  createdAt
  internal
  fromBot
  contentType

  engageData {
    content
    kind
    sentAs
    messageId
    brandId
  }
  botData
  messengerAppData
  attachments {
    url
    name
    size
    type
  }
`

const CLOUDFLARE_CALL = `
  mutation cloudflareMakeCall(
    $callerNumber: String!
    $callerEmail: String
    $roomState: String!
    $origin: String!
    $audioTrack: String!
    $integrationId: String!
    $departmentId: String!
    $roomName: String
    $language: String
  ) {
    cloudflareMakeCall(
      callerNumber: $callerNumber
      callerEmail: $callerEmail
      roomState: $roomState
      origin: $origin
      audioTrack: $audioTrack
      integrationId: $integrationId
      departmentId: $departmentId
      roomName: $roomName
      language: $language
    )
  }
`;

const LIVEKIT_PRE_CALL = `
  mutation LivekitPreCall {
    livekitHandshake {
      roomName,
      serverUrl,
      token
    }
  }
`;

const LIVEKIT_SAVE_TRANSCRIPTION = `
  mutation LivekitSendTransciption (
    $chunk: String!
    $integrationId: String!
    $audioTrack: String
    $callerNumber: String
  ) {
    livekitSendTransciption (
      chunk: $chunk
      integrationId: $integrationId 
      audioTrack: $audioTrack
      callerNumber: $callerNumber
    )
  }
`;

const CLOUDFLARE_LEAVE_CALL = `
  mutation CloudflareLeaveCall(
    $originator: String
    $duration: Int
    $audioTrack: String!
    $roomName: String
    $roomState: String
  ) {
    cloudflareLeaveCall(
      originator: $originator
      duration: $duration
      audioTrack: $audioTrack
      roomName: $roomName
      roomState: $roomState
    )
  }
`;

const CLOUDFLARE_CALL_RECEIVED = `
  subscription cloudflareReceivedCall($roomState: String, $audioTrack: String)
  {
    cloudflareReceivedCall(roomState: $roomState, audioTrack: $audioTrack){
      callerNumber
      roomState
      sessionId
      trackName
      audioTrack
      conversationId
      customerAudioTrack
      roomName
    }
  }`;


export default {
  messageFields,
  conversationDetailQuery,
  widgetExportMessengerDataQuery,
  unreadCountQuery,
  totalUnreadCountQuery,
  conversationMessageInserted,
  adminMessageInserted,
  conversationChanged,
  allConversations,
  connect,
  saveBrowserInfo,
  sendTypingInfo,
  readConversationMessages,
  messengerSupportersQuery,
  getFaqCategoryQuery,
  getFaqTopicQuery,
  faqSearchArticlesQuery,
  integrationsFetchApi,
  conversationMessageFeedback,
  removeConversationMessageFeedback,
  conversationBotTypingStatus,
  getEngageMessage,
  conversationMessageStreamSubscription,
  conversationReasoningStream,

  USER_DETAIL_FIELD,
  MESSAGE_FIELDS,
  LIVEKIT_PRE_CALL,
  LIVEKIT_SAVE_TRANSCRIPTION,
  CLOUDFLARE_CALL,
  CLOUDFLARE_LEAVE_CALL,
  CLOUDFLARE_CALL_RECEIVED
};
